<template>
  <div class="detail-container">
    <!-- 返回按钮 -->
    <!-- <button @click="goBack" class="back-button">返回</button> -->
    
    <!-- 加载状态 -->
    <div v-if="loading" class="loading-container">
      <div class="loading-spinner"></div>
      <p>加载中...</p>
    </div>

    <!-- 错误状态 -->
    <div v-else-if="error" class="error-container">
      <p>加载失败：{{ error }}</p>
      <button @click="fetchDetailData" class="retry-button">重试</button>
    </div>

    <!-- 内容区域 -->
    <div v-else-if="detailData" class="content-container">
      <!-- <div class="common-layout">
        <h1>详情页面</h1>
      </div> -->

      <!-- 第一段布局 -->
      <div v-if="validImageUrls.length >= 1" class="productDetail_one">
        <template v-for="(url, index) in validImageUrls" :key="`detail-${index}`">
          <video
            v-if="isVideo(trimImageUrl(url))"
            :src="trimImageUrl(url)"
            autoplay muted loop playsinline
          />
          <img
            v-else
            :src="trimImageUrl(url)"
            :alt="`Detail Image ${index + 1}`"
          >
        </template>
      </div>


<!--      <div v-if="validImageUrls.length >= 3" class="productDetail_one">-->
<!--        <img :src="trimImageUrl(validImageUrls[1])" :alt="'Detail Image 2'">-->
<!--        <img :src="trimImageUrl(validImageUrls[2])" :alt="'Detail Image 3'">-->
<!--      </div>-->

<!--       <div v-if="validImageUrls.length >= 4" class="productDetail_one">-->
<!--           <img :src="trimImageUrl(validImageUrls[3])" :alt="'Detail Image 4'">-->
<!--      </div>-->

<!--      <div v-if="validImageUrls.length >= 5" class="productDetail_one">-->
<!--          <img :src="trimImageUrl(validImageUrls[4])" :alt="'Detail Image 5'">-->
<!--      </div>-->
<!--      <div v-if="validImageUrls.length >= 6" class="productDetail_one">-->
<!--          <img :src="trimImageUrl(validImageUrls[5])" :alt="'Detail Image 5'">-->
<!--      </div>-->
<!--      <div v-if="validImageUrls.length >= 7" class="productDetail_one">-->
<!--          <img :src="trimImageUrl(validImageUrls[6])" :alt="'Detail Image 5'">-->
<!--      </div>-->
<!--      <div v-if="validImageUrls.length >= 8" class="productDetail_one">-->
<!--          <img :src="trimImageUrl(validImageUrls[7])" :alt="'Detail Image 5'">-->
<!--      </div>-->


      <!-- 第二段布局 -->
      <!-- <div v-if="validImageUrls.length >= 3" class="productDetail_two">
        <div class="two_left">
            <div class="two_left_top">
              <img :src="trimImageUrl(validImageUrls[1])" :alt="'Detail Image 2'">
            </div>
            <div class="two_left_bottom">
              <img :src="trimImageUrl(validImageUrls[2])" :alt="'Detail Image 3'">
            </div>
        </div>
        <div v-if="validImageUrls.length >= 4" class="two_right">
           <img :src="trimImageUrl(validImageUrls[3])" :alt="'Detail Image 4'">
        </div>
      </div> -->

      <!-- 第三段布局 -->
      <!-- <div v-if="validImageUrls.length >= 5" class="productDetail_three">
        <div class="three_top">
          <img :src="trimImageUrl(validImageUrls[4])" :alt="'Detail Image 5'">
        </div>
        
         <div class="three_middle_left">
              <img :src="trimImageUrl(validImageUrls[5])" :alt="'Detail Image 6'">
        </div>
        <div v-if="validImageUrls.length >= 7" class="three_middle">
            <div class="three_middle_right">
              <img :src="trimImageUrl(validImageUrls[6])" :alt="'Detail Image 7'">
            </div>
        </div>
        <div v-if="validImageUrls.length >= 8" class="three_bottom">
          <img :src="trimImageUrl(validImageUrls[7])" :alt="'Detail Image 8'">
        </div>
      </div> -->

      <!-- 剩余图片显示 -->
<!--      <div v-if="remainingImages.length > 0" class="remaining-images">-->
<!--        <div v-for="(imageUrl, index) in remainingImages" :key="index" class="remaining-image-item">-->
<!--          <img :src="trimImageUrl(imageUrl)" :alt="`Detail Image ${index + 8}`">-->
<!--        </div>-->
<!--      </div>-->
    </div>

    <!-- 无数据状态 -->
    <div v-else class="empty-container">
      <p>暂无数据</p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
// 定义详情数据类型
interface DetailData {
  id: number;
  topicId: number;
  flag: number;
  imageUrl1?: string | null;
  imageUrl2?: string | null;
  imageUrl3?: string | null;
  imageUrl4?: string | null;
  imageUrl5?: string | null;
  imageUrl6?: string | null;
  imageUrl7?: string | null;
  imageUrl8?: string | null;
  imageUrl9?: string | null;
  imageUrl10?: string | null;
  imageUrl11?: string | null;
  imageUrl12?: string | null;
  imageUrl13?: string | null;
  imageUrl14?: string | null;
  imageUrl15?: string | null;
  imageUrl16?: string | null;
  imageUrl17?: string | null;
  imageUrl18?: string | null;
  imageUrl19?: string | null;
  imageUrl20?: string | null;
}

// 定义API响应的数据类型
interface ApiResponse {
  code: number;
  result: DetailData;
  message: string;
}

export default defineComponent({
  setup() {
    const route = useRoute();
    const router = useRouter();
    const detailData = ref<DetailData | null>(null);
    const loading = ref<boolean>(false);
    const { locale } = useI18n();
    const error = ref<string>('');

    // 获取有效的图片URL数组
    const validImageUrls = computed(() => {
      if (!detailData.value) return [];
      
      const urls: string[] = [];
      for (let i = 1; i <= 20; i++) {
        const url = (detailData.value as any)[`imageUrl${i}`];
        if (url) {
          urls.push(url);
        }
      }
      return urls;
    });

    // 计算剩余图片（超过8张的部分）
    const remainingImages = computed(() => {
      return validImageUrls.value.slice(8);
    });

    // 获取详情数据的方法 - 修改版
    const fetchDetailData = async () => {
      const topicId = route.query.topicId as string;
      if (!topicId) {
        error.value = '参数错误';
        return;
      }

      // 根据来源设置不同的flag值
      // 从产品分类点击过来时，flag=2
      // 其他情况保持默认flag=1
      const fromCategory = route.query.from === 'category';
      const flag = fromCategory ? '2' : '1';

      loading.value = true;
      error.value = '';
      
      try {
        // 调用详情接口，传递正确的topicId和flag
        // const response = await fetch(`http://172.16.10.48:8080/jeecg-boot/drmotoev/detail/get?topicId=${topicId}&flag=${flag}`);
        let response;
        if (locale.value === 'en') {
          response = await fetch(`/jeecg-boot/drmotoev/detail/get/en?topicId=${topicId}&flag=${flag}`);
        } else {
          response = await fetch(`/jeecg-boot/drmotoev/detail/get?topicId=${topicId}&flag=${flag}`);
        }
        // const response = await fetch(`/jeecg-boot/drmotoev/detail/get?topicId=${topicId}&flag=${flag}`);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data: ApiResponse = await response.json();
        
        // 检查响应代码
        if (data.code === 200) {
          detailData.value = data.result || null;
        } else {
          throw new Error(data.message || '获取详情数据失败');
        }
      } catch (err) {
        error.value = err instanceof Error ? err.message : '未知错误';
        console.error('获取详情数据失败:', err);

        detailData.value = {
          id: 1,
          topicId: Number(topicId),
          flag: 1,
          imageUrl1: " `https://newrockb2b.oss-cn-shenzhen.aliyuncs.com/0000/A86ARH_1774322565677.mp4` ",
          imageUrl2: " `https://newrockb2b.oss-cn-shenzhen.aliyuncs.com/images/1760146321381_sVKx772Cf-UYUxJIFV47cMlQGoKSz53J05gu0tvQraBOu8vYrA0bJTaFC25K2wer.jpg` ",
          imageUrl3: " `https://newrockb2b.oss-cn-shenzhen.aliyuncs.com/0000/A86ARH_1774322565677.mp4` ",
          imageUrl4: " `https://newrockb2b.oss-cn-shenzhen.aliyuncs.com/images/1760147860319_nvm%E5%B8%B8%E7%94%A8%E5%91%BD%E4%BB%A4.png` ",
          imageUrl5: " `https://newrockb2b.oss-cn-shenzhen.aliyuncs.com/images/1760147863395_sVKx772Cf-UYUxJIFV47cMlQGoKSz53J05gu0tvQraBOu8vYrA0bJTaFC25K2wer.jpg` ",
          imageUrl6: " `https://newrockb2b.oss-cn-shenzhen.aliyuncs.com/0000/A86ARH_1774322565677.mp4` ",
          imageUrl7: " `https://newrockb2b.oss-cn-shenzhen.aliyuncs.com/images/1760147866556_nvm%E5%B8%B8%E7%94%A8%E5%91%BD%E4%BB%A4.png` "
        };
      } finally {
        loading.value = false;
      }
    };

    // 处理图片URL中的额外字符
    const trimImageUrl = (url: string): string => {
      return url.replace(/^[\s`]+|[\s`]+$/g, '');
    };

    const isVideo = (url: any) => {
      const videoExts = ['.mp4', '.webm', '.ogg', '.mov'];
      return videoExts.some(ext => url?.toLowerCase().includes(ext));
    };

    // 返回上一页
    const goBack = () => {
      router.back();
    };

    // 监听路由参数变化，当topicId改变时重新获取数据
    watch(
      () => route.query.topicId,
      (newTopicId, oldTopicId) => {
        if (newTopicId !== oldTopicId) {
          fetchDetailData();
        }
      }
    );

    // 监听语言变化，重新获取数据
    watch(locale, () => {
      fetchDetailData();
    });

    // 组件挂载时获取数据
    onMounted(() => {
      fetchDetailData();
    });

    return {
      detailData,
      loading,
      error,
      validImageUrls,
      remainingImages,
      fetchDetailData,
      trimImageUrl,
      isVideo,
      goBack
    };
  }
});
</script>

<style scoped>
.detail-container {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
}

.back-button {
  align-self: flex-start;
  padding: 8px 16px;
  background-color: #12aa4a;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 20px;
  transition: background-color 0.3s;
}

.back-button:hover {
  background-color: #0e8e3e;
}

.content-container {
  width: 100%;
  max-width: 1200px;
}

/* MollyProductDetail风格的布局样式 */
.productDetail_one {
  width: 90%;
  border-radius: 20px;
  margin: 0 auto;
  overflow: hidden; /* 防止图片溢出容器 */
}

.productDetail_two {
  width: 90%;
  border-radius: 20px;
  margin: 10px auto;
  display: flex;
  overflow: hidden; /* 防止图片溢出容器 */
}

.two_left {
  width: 50%;
  height: 100%;
  border-radius: 20px;
  overflow: hidden; /* 新增：防止图片溢出容器 */
}

.two_left_top {
  width: 100%;
  height: 50%;
  border-radius: 20px;
  overflow: hidden; /* 新增：防止图片溢出容器 */
}

.two_left_bottom {
  width: 100%;
  height: 50%;
  border-radius: 20px;
  overflow: hidden; /* 新增：防止图片溢出容器 */
}

.two_right {
  width: 50%;
  height: 100%;
  border-radius: 20px;
  overflow: hidden;
}


.productDetail_three {
  width: 90%;
  margin: 10px auto;
  overflow: hidden; /* 防止图片溢出容器 */
}

.three_top {
  width: 100%;
  height: 15%;
  border-radius: 20px;
  overflow: hidden; /* 新增：防止图片溢出容器 */
}

.three_middle {
  width: 100%;
  height: 44%;
  border-radius: 20px;
  margin-top: 1%;
  overflow: hidden; /* 新增：防止图片溢出容器 */
}

.three_middle_left {
  width: 49%;
  height: 100%;
  border-radius: 20px;
  float: left;
  overflow: hidden; /* 新增：防止图片溢出容器 */
}

.three_middle_right {
  width: 49%;
  height: 100%;
  border-radius: 20px;
  float: right;
  overflow: hidden; /* 新增：防止图片溢出容器 */
}

.three_bottom {
  width: 100%;
  height: 39%;
  border-radius: 20px;
  margin-top: 1%;
  overflow: hidden;
}

/* 图片样式 */
.productDetail_one > img,
.productDetail_one > video,
.two_left_top > img,
.two_left_bottom > img,
.two_right > img,
.three_top > img,
.three_middle_left > img,
.three_middle_right > img,
.three_bottom > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 20px;
  transition: all 0.3s ease;
}

.productDetail_one > img:hover,
.productDetail_one > video:hover,
.two_left_top > img:hover,
.two_left_bottom > img:hover,
.two_right > img:hover,
.three_top > img:hover,
.three_middle_left > img:hover,
.three_middle_right > img:hover,
.three_bottom > img:hover {
  transform: scale(1.02);
}

/* 剩余图片样式 */
.remaining-images {
  width: 90%;
  margin: 10px auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}

.remaining-image-item {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  overflow: hidden;
}

.remaining-image-item > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 20px;
  transition: all 0.3s ease;
}

.remaining-image-item > img:hover {
  transform: scale(1.02);
}

/* 加载状态样式 */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 400px;
  width: 100%;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top-color: #12aa4a;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* 错误状态样式 */
.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 400px;
  width: 100%;
  color: #ff4d4f;
}

.retry-button {
  margin-top: 16px;
  padding: 6px 16px;
  background-color: #12aa4a;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.retry-button:hover {
  background-color: #0e8e3e;
}

/* 空数据状态样式 */
.empty-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
  width: 100%;
  color: #999;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .productDetail_two {
    flex-direction: column;
  }
  
  .two_left,
  .two_right {
    width: 100%;
    margin-bottom: 10px;
  }
  
  .three_middle_left,
  .three_middle_right {
    float: none;
    width: 100%;
    margin-bottom: 10px;
  }
  
  .remaining-images {
    grid-template-columns: 1fr;
    gap: 15px;
  }
}
</style>